import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Box, Menu, Avatar, Typography, Divider, Button } from '@mui/material';
import * as dropdownData from './data';

import { IconMail } from '@tabler/icons';
import { Stack } from '@mui/system';

import Scrollbar from 'src/components/custom-scroll/Scrollbar';
import AlertBox from 'src/components/material-ui/dialog/AlertBox';
import { useDispatch, useSelector } from 'react-redux';
import { logout, userSelector } from 'src/store/apps/slices/UserSlice';
import { clearAllState } from 'src/lib/utils';
import { handleInvalidToken } from 'src/store/apps/slices/AppSlice';
import { clearOtpChallengeStorage } from 'src/lib/auth/otpSession';
import { toast } from 'react-toastify';

const Profile = () => {
  const [open, setOpen] = useState(false);
  const { user, loading } = useSelector(userSelector);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const firstName = (user?.name || '').trim().split(/\s+/)[0] || '';
  const avatarInitial = firstName.charAt(0).toUpperCase() || 'A';
  const [anchorEl2, setAnchorEl2] = useState(null);
  const handleClick2 = (event) => {
    setAnchorEl2(event.currentTarget);
  };
  const handleClose2 = () => {
    setAnchorEl2(null);
  };

  const handleLogout = () => {
    dispatch(logout())
    .unwrap()
    .then(() => {
      clearAllState();
      // Logout may trigger a 401 interceptor before/after token invalidation.
      // Ensure we don't keep the "Session Expired" dialog open on the sign-in screen.
      dispatch(handleInvalidToken(false));
      // Also clear any OTP challenge that could make the login page show expired OTP UI.
      clearOtpChallengeStorage();
      navigate('/auth/login', { replace: true })
    })
    .catch(()=> {
      toast.error("Logout failed. Try Again.")
    })
  }

  return (
    <Box>
      <Box
        onClick={handleClick2}
        aria-controls="msgs-menu"
        aria-haspopup="true"
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          cursor: 'pointer',
          px: 0.5,
          py: 0.5,
          borderRadius: 1,
        }}
      >
        {firstName && (
          <Typography
            variant="subtitle2"
            color="textPrimary"
            fontWeight={600}
            sx={{ display: { xs: 'none', sm: 'block' } }}
          >
            {firstName}
          </Typography>
        )}
        <Avatar
          alt={firstName || user?.name || 'User'}
          sx={{
            width: 35,
            height: 35,
            bgcolor: 'primary.main',
            fontSize: 14,
            fontWeight: 600,
          }}
        >
          {avatarInitial}
        </Avatar>
      </Box>
      {/* ------------------------------------------- */}
      {/* Message Dropdown */}
      {/* ------------------------------------------- */}
      <Menu
        id="msgs-menu"
        anchorEl={anchorEl2}
        keepMounted
        open={Boolean(anchorEl2)}
        onClose={handleClose2}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        sx={{
          '& .MuiMenu-paper': {
            width: '360px',
          },
        }}
      >
        <Scrollbar sx={{ height: '100%', maxHeight: '85vh' }}>
          <Box p={3}>
            <Typography variant="h5">User Profile</Typography>
            <Stack direction="row" py={3} spacing={2} alignItems="center">
              <Avatar
                alt={firstName || user?.name || 'User'}
                sx={{ width: 95, height: 95, bgcolor: 'primary.main', fontSize: 36, fontWeight: 600 }}
              >
                {avatarInitial}
              </Avatar>
              <Box>
                <Typography variant="subtitle2" color="textPrimary" fontWeight={600}>
                  {user?.name}
                </Typography>
                <Typography variant="subtitle2" color="textSecondary">
                  {user?.role}
                </Typography>
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  display="flex"
                  alignItems="center"
                  gap={1}
                >
                  <IconMail width={15} height={15} />
                  {user?.email}
                </Typography>
              </Box>
            </Stack>
            <Divider />
            <Box mt={2}>
              {/* <Box bgcolor="primary.light" p={3} mb={3} overflow="hidden" position="relative">
                <Box display="flex" justifyContent="space-between">
                  <Box>
                    <Typography variant="h5" mb={2}>
                      Unlimited <br />
                      Access
                    </Typography>
                    <Button variant="contained" color="primary">
                      Upgrade
                    </Button>
                  </Box>
                  <img src={unlimitedImg} alt="unlimited" className="signup-bg"></img>
                </Box>
              </Box> */}
              <Button onClick={() => setOpen(true)} variant="outlined" color="primary" fullWidth>
                Logout
              </Button>
            </Box>
          </Box>
        </Scrollbar>
      </Menu>
      {open && (
        <AlertBox
          open={open}
          handleClose={() => setOpen(false)}
          handleConfirm={handleLogout}
          title="Are you sure to logout!"
          disabled={loading}
        />
      )}
    </Box>
  );
};

export default Profile;
